import React, { useState, useEffect } from "react";
import EmailIcon from '../../../assets/images/Union.svg';
import { Image } from "../../../components/componentIndex";
import { Button, Input, CheckedImage } from '../../../common/commonIndex';


const StepName = ({ handleNextEvent, formData, getPersonalInfo, updatePersonalInfo }) => {
    const [firstName, setFirstName] = useState(formData?.firstName || '');

    const [lastName, setLastName] = useState(formData?.lastName || '');
    const [isFirstNameValid, setIsFirstNameValid] = useState(false);
    const [isFirstNameError, setIsFirstNameError] = useState(false);
    const [isLastNameValid, setIsLastNameValid] = useState(false);
    const [isLastNameError, setIsLastNameError] = useState(false);
    const [isSubmited, setIsSubmited] = useState(false);

    useEffect(() => {
        if (formData?.firstName) {
            setFirstName(formData?.firstName);
            setIsFirstNameValid(formData?.firstName?.trim() !== '' ? true : false);
        } else {
            setFirstName('');
            setIsFirstNameValid(false);
        }
        if (formData?.lastName) {
            setLastName(formData?.lastName);
            setIsLastNameValid(formData?.firstName?.trim() !== '' ? true : false);
        } else {
            setLastName('');
            setIsLastNameValid(false);
        }
        if (formData.email && formData.firstName && formData.lastName && formData.sex && formData.day && formData.month && formData.year) {
            getPersonalInfo();
        }
    });
    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
      };
    // Handle first name input change
    const handleFirstNameChange = (e) => {
        const value = e && e !== '' ?  capitalizeFirstLetter(e) : e;
        setFirstName(value);
        setIsFirstNameValid(value?.trim() !== '' ? true : false);
        formData.firstName = value;
        setIsFirstNameError(value?.trim() !== '' ? false : true);
    };

    // Handle last name input change
    const handleLastNameChange = (e) => {
        const value = e && e !== '' ?  capitalizeFirstLetter(e) : e;
        setLastName(value);
        setIsLastNameValid(value?.trim() !== '' ? true : false);
        formData.lastName = value;
        setIsLastNameError(value?.trim() !== '' ? false : true);
    };
    const isValid = (value) => {
        return value?.trim() !== '' ? true : false;
    }
    // Handle form submission
    const handleSubmit = (e) => {
        setIsSubmited(true);
        e.preventDefault();
        if (formData.email && formData.firstName && formData.lastName && formData.sex && formData.day && formData.month && formData.year) {
            updatePersonalInfo(formData)
        } else {
            handleNextEvent(4);
        }
    };
    const isFormValid = isFirstNameValid && isLastNameValid;
    return (
        <div className="name-form-container">
            <h2 className="title">Enter your name</h2>
            <p className="sub-title">For your health record, please use your full legal name.</p>

            <form onSubmit={handleSubmit}>
                <div className="">
                    <div className={`input-group ${isFirstNameValid && isSubmited ? 'valid' : ''}`}>
                        {/* <Image imgUrl={EmailIcon} altText="Email" /> */}
                        <Input inputType={'text'} inputPlaceholder={'First name'} className={'form-control'} required={true} onChange={handleFirstNameChange}
                            value={firstName} />
                        {isFirstNameValid && (
                            <CheckedImage />
                        )}
                    </div>
                    {/* {isFirstNameError && ( */}
                        <div className="error-content name-error">
                            <p className="is-error mb-0">{isFirstNameError && isSubmited ? 'First name is required' : ''}</p>
                        </div>
                    {/* )} */}
                </div>

                <div className="margin-bottom-40">
                    <div className={`input-group  ${isLastNameValid && isSubmited ? 'valid' : ''}`}>
                        {/* <Image imgUrl={EmailIcon} altText="Email" /> */}
                        <Input inputType={'text'} inputPlaceholder={'Last name'} className={'form-control'} required={true} onChange={handleLastNameChange}
                            value={lastName}
                        />
                        {isLastNameValid  && (
                            <CheckedImage />
                        )}

                    </div>
                    {/* {isLastNameError && ( */}
                        <div className="error-content name-error">
                            <p className="is-error mb-0">{isLastNameError && isSubmited ? 'Last name is required' : '' }</p>
                        </div>
                    {/* )} */}
                </div>

                <Button
                    btnClass={'btn-primary'}
                    btnType={'submit'}
                    btnName={'Next'}
                    onClick={handleSubmit}
                    isDisabled={isFormValid}
                />
            </form>
        </div>
    );
};

export default StepName;